(() => {
  'use strict';

  const VERSION = '20260717-product-footer-guard-v23';
  const STYLE_ID = 'alpha-product-footer-guard-v23-style';
  const PRODUCT_PATH = /\/products\//;

  if (!PRODUCT_PATH.test(window.location.pathname)) return;
  if (window.__alphaProductFooterGuardV23 === VERSION) return;
  window.__alphaProductFooterGuardV23 = VERSION;

  const css = `
    html body #shopify-section-group-footer-group,
    html body .shopify-section-group-footer-group,
    html body .section-alpha-footer-premium-v2,
    html body .shopify-section.section-alpha-footer-premium-v2,
    html body .section-alpha-footer-premium-v2 > footer,
    html body footer[class^="af2-"],
    html body footer[class*=" af2-"] {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      position: relative !important;
      inset: auto !important;
      float: none !important;
      clear: both !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: none !important;
      height: auto !important;
      min-height: 1px !important;
      max-height: none !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      transform: none !important;
      translate: none !important;
      scale: none !important;
      rotate: none !important;
      contain: none !important;
      content-visibility: visible !important;
      clip: auto !important;
      clip-path: none !important;
      pointer-events: auto !important;
    }

    html body #shopify-section-group-footer-group,
    html body .shopify-section-group-footer-group,
    html body .section-alpha-footer-premium-v2,
    html body .shopify-section.section-alpha-footer-premium-v2 {
      overflow: visible !important;
      z-index: 1 !important;
    }

    html body.alpha-product-museum #MainContent,
    html body.alpha-product-museum .content-for-layout {
      display: block !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      overflow: visible !important;
      contain: none !important;
      content-visibility: visible !important;
    }

    html body.alpha-product-museum.alpha-footer-v23-in-view .alpha-mobile-format-cta {
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
      transform: translateY(18px) !important;
    }
  `;

  let frame = 0;
  let rootObserver = null;
  let targetObserver = null;
  let visibilityObserver = null;
  let observedFooterUnit = null;

  const setImportant = (node, property, value) => {
    if (!(node instanceof HTMLElement)) return;
    if (
      node.style.getPropertyValue(property) === value &&
      node.style.getPropertyPriority(property) === 'important'
    ) return;
    node.style.setProperty(property, value, 'important');
  };

  const removeInline = (node, property) => {
    if (!(node instanceof HTMLElement)) return;
    if (!node.style.getPropertyValue(property)) return;
    node.style.removeProperty(property);
  };

  const mountStyle = () => {
    let style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }
    if (style.textContent !== css) style.textContent = css;
  };

  const reveal = (node, isContainer = false) => {
    if (!(node instanceof HTMLElement)) return;

    if (node.hidden) node.hidden = false;
    if (node.hasAttribute('hidden')) node.removeAttribute('hidden');
    if (node.hasAttribute('aria-hidden')) node.removeAttribute('aria-hidden');
    if (node.hasAttribute('inert')) node.removeAttribute('inert');

    const properties = {
      display: 'block',
      visibility: 'visible',
      opacity: '1',
      position: 'relative',
      inset: 'auto',
      float: 'none',
      clear: 'both',
      width: '100%',
      'min-width': '0',
      'max-width': 'none',
      height: 'auto',
      'min-height': '1px',
      'max-height': 'none',
      'margin-left': '0',
      'margin-right': '0',
      transform: 'none',
      translate: 'none',
      scale: 'none',
      rotate: 'none',
      contain: 'none',
      'content-visibility': 'visible',
      clip: 'auto',
      'clip-path': 'none',
      'pointer-events': 'auto'
    };

    Object.entries(properties).forEach(([property, value]) => {
      setImportant(node, property, value);
    });

    if (isContainer) {
      setImportant(node, 'overflow', 'visible');
      setImportant(node, 'z-index', '1');
    }

    node.dataset.alphaFooterGuard = VERSION;
  };

  const locate = () => {
    const footer = document.querySelector(
      'footer[class^="af2-"], footer[class*=" af2-"]'
    );

    const section =
      document.querySelector(
        '.shopify-section.section-alpha-footer-premium-v2, .section-alpha-footer-premium-v2'
      ) ||
      (footer instanceof HTMLElement
        ? footer.closest('.shopify-section') || footer.parentElement
        : null);

    const group =
      document.getElementById('shopify-section-group-footer-group') ||
      document.querySelector('.shopify-section-group-footer-group');

    return {
      footer: footer instanceof HTMLElement ? footer : null,
      section: section instanceof HTMLElement ? section : null,
      group: group instanceof HTMLElement ? group : null
    };
  };

  const placeAfterMain = (unit) => {
    const main = document.getElementById('MainContent');
    if (!(main instanceof HTMLElement) || !(unit instanceof HTMLElement)) return;
    const parent = main.parentNode;
    if (!(parent instanceof Node)) return;

    const alreadyAfter =
      unit.parentNode === parent &&
      Boolean(main.compareDocumentPosition(unit) & Node.DOCUMENT_POSITION_FOLLOWING);

    if (main.contains(unit) || !alreadyAfter || !unit.isConnected) {
      parent.insertBefore(unit, main.nextSibling);
    }
  };

  const unlockPage = () => {
    const dialogOpen = document.querySelector('.amp-dialog[open], dialog[open].amp-dialog');
    if (dialogOpen) return;

    const html = document.documentElement;
    const body = document.body;
    if (!(body instanceof HTMLElement)) return;

    if (body.classList.contains('amp-open')) body.classList.remove('amp-open');

    [html, body].forEach((node) => {
      ['overflow', 'overflow-x', 'overflow-y', 'height', 'min-height', 'max-height', 'position', 'inset', 'top', 'right', 'bottom', 'left', 'width'].forEach((property) => {
        removeInline(node, property);
      });
    });

    setImportant(body, 'height', 'auto');
    setImportant(body, 'min-height', '100%');
    setImportant(body, 'max-height', 'none');
    setImportant(body, 'overflow-y', 'auto');
  };

  const normalizeMain = () => {
    const main = document.getElementById('MainContent');
    if (!(main instanceof HTMLElement)) return;
    setImportant(main, 'display', 'block');
    setImportant(main, 'height', 'auto');
    setImportant(main, 'min-height', '0');
    setImportant(main, 'max-height', 'none');
    setImportant(main, 'overflow', 'visible');
    setImportant(main, 'contain', 'none');
    setImportant(main, 'content-visibility', 'visible');
  };

  const watchVisibility = (unit) => {
    if (!(unit instanceof HTMLElement) || !('IntersectionObserver' in window)) return;
    if (observedFooterUnit === unit && visibilityObserver) return;

    if (visibilityObserver) visibilityObserver.disconnect();
    observedFooterUnit = unit;

    visibilityObserver = new IntersectionObserver(
      (entries) => {
        const visible = entries.some(
          (entry) => entry.isIntersecting && entry.intersectionRatio > 0
        );
        document.body?.classList.toggle('alpha-footer-v23-in-view', visible);
      },
      { threshold: [0, 0.01, 0.1] }
    );

    visibilityObserver.observe(unit);
  };

  const observeTargets = (targets) => {
    if (targetObserver) targetObserver.disconnect();

    targetObserver = new MutationObserver(() => schedule());
    const options = {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden', 'inert']
    };

    targets.forEach((target) => {
      if (target instanceof HTMLElement) targetObserver.observe(target, options);
    });
  };

  const apply = () => {
    mountStyle();
    unlockPage();
    normalizeMain();

    const { footer, section, group } = locate();
    const unit = group || section;

    if (group) reveal(group, true);
    if (section) reveal(section, true);
    if (footer) reveal(footer, false);
    if (unit) {
      placeAfterMain(unit);
      watchVisibility(unit);
    }

    observeTargets([
      document.documentElement,
      document.body,
      document.getElementById('MainContent'),
      group,
      section,
      footer
    ]);
  };

  function schedule() {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      apply();
    });
  }

  const observeRoot = () => {
    if (!document.documentElement || rootObserver) return;
    rootObserver = new MutationObserver((mutations) => {
      if (
        mutations.some(
          (mutation) => mutation.addedNodes.length || mutation.removedNodes.length
        )
      ) schedule();
    });
    rootObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  };

  mountStyle();
  schedule();
  observeRoot();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  }

  window.addEventListener('load', schedule, { once: true });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  document.addEventListener('shopify:section:select', schedule);

  [30, 100, 250, 600, 1200, 2500, 5000, 10000, 20000].forEach((delay) => {
    window.setTimeout(schedule, delay);
  });
})();
